import { ROBKeys } from "components/ROB/queryKeys";
import { useTypedQuery } from "hooks";
import { ApiInstance } from "utils/Api";

export const useROBServiceRequestQuery = (car_id: number, isRobnetEnabled: boolean) =>
  useTypedQuery({
    queryKey: ROBKeys.serviceRequest(car_id),
    queryFn: async ({ baseUrl, endpoint, params }) => (await ApiInstance.post(endpoint, params, baseUrl))?.data?.data ?? null,
    enabled: false,
    refetchOnDependencies: [car_id, isRobnetEnabled]
  });
